/**
 * "Can we reach ProCharted?" (QA batch 16, NAV-026). Set by
 * `connectionMiddleware` from RTK Query results; read by `ConnectionBanner`.
 */
type Listener = () => void;

let offline = false;
const listeners = new Set<Listener>();

export const isApiOffline = () => offline;

export const setApiOffline = (next: boolean) => {
  if (offline === next) return;
  offline = next;
  listeners.forEach((listener) => listener());
};

export const subscribeApiOffline = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
